"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateInvoiceStartTransport = exports.GenerateInvoiceTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const payment_processing_1 = require("./payment-processing");
exports.GenerateInvoiceTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    suppressIssueInvoice: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    chargeNowPaymentProcessor: typebox_1.Type.Optional(payment_processing_1.SupportedPaymentProcessorTransport),
    chargeNowPaymentMethodID: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.GenerateInvoiceStartTransport = typebox_1.Type.Omit(exports.GenerateInvoiceTransport, ['id']);
//# sourceMappingURL=subscription-billing-period-invoice-generate-transport.js.map